import loadable from '@loadable/component';

// 懒加载组件
const ItemNewApplicationWithSelection = loadable(() => import('./itemNewApplicationWithSelection/ItemNewApplicationWithSelection'));
const CstStatementConfirmationManagement = loadable(() => import('./cstStatementConfirmationManagement/CstStatementConfirmationManagement'));
const CstStatementConfirmationModify = loadable(() => import('./cstStatementConfirmationManagement/cstStatementConfirmationModify/CstStatementConfirmationModify'));

export const subRoutes = [
  {
    path: '/ItemNewApplicationWithSelection',
    component: ItemNewApplicationWithSelection
  },
  {
    path: '/CstStatementConfirmationManagement',
    component: CstStatementConfirmationManagement
  },
  {
    path: '/CstStatementConfirmationModify',
    component: CstStatementConfirmationModify
  }
];
